export const mediaSpeeds = [1, 1.2, 1.5, 1.7, 2]
export const scales = [0.25, 0.5, 0.75, 1, 1.25, 1.5, 1.75, 2]
export const percentFormatter = new Intl.NumberFormat('en-US', { style: 'percent' })
